import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CpsNavigationService } from 'src/services/cps-navigation.service';
import { DatalayerService } from 'src/services/datalayer.service';
import { LocalStorage } from 'src/utils/local-storage';

@Component({
  selector: 'app-go-to-cps-panel',
  templateUrl: './go-to-cps-panel.component.html',
  styleUrls: ['./go-to-cps-panel.component.scss']
})
export class GoToCpsPanelComponent implements OnInit {

  constructor(private cpsNav: CpsNavigationService, private datalayerService: DatalayerService, private localStorage: LocalStorage) { }

  ngOnInit(): void {
  }

  goToCps() {
    this.cpsNav.goToCps();
    this.trackGoToCps(environment.CPS2_DOMAIN);
  }

  trackGoToCps(url: string) {
    this.datalayerService.hubClick(
      "go_to_cps", 
      "go_to_cps", 
      "Go to CPS",
      url
    );
  }
}
